import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TemplateItemProps } from "apis/template";
import { PaginationProps } from "utils/types/API";

export interface TemplateState {
    loading: boolean;
    list: {
        data: TemplateItemProps[];
        options: TemplateItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: TemplateItemProps;
    };
}

const initialState: TemplateState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: TemplateItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: TemplateItemProps;
}
export const templateSlice = createSlice({
    name: "template",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = templateSlice.actions;
export default templateSlice.reducer;
